import styles from './TabItem.module.scss';

export default function TabItem({id,title, icon, type, activeTab, setActiveTab, handleTabClick}) {

    const handleActiveClick = (e) => {
        e.preventDefault();
        handleTabClick(id);
      };
      
  return (
    <>
        <div onClick={handleActiveClick} className={`d-inline-block me-4 py-2 ${styles.tabHeaderItem} ${activeTab == id ? styles.active : ""}` }>
            {
                icon && (
                    <i className={`${icon} me-2`}></i>
                )
            }
            <a href={`#${type}`}>{title}</a>
        </div>
    </>
  )
}
